import { isValidElement, type ReactNode } from "react"

/** The fenced code react-markdown passes to a `pre` override as `<code className="language-x">`. */
export function readMarkdownCode(children: ReactNode): { code: string; language: string } {
  const props = isValidElement(children)
    ? (children.props as { className?: string; children?: ReactNode })
    : undefined
  const language = /language-(\S+)/.exec(props?.className ?? "")?.[1] ?? ""
  return { code: String(props?.children ?? ""), language }
}
